import { createSvgIcon } from "@mui/material/utils";

export default createSvgIcon(
  <path
    d="M13 18V6L21.5 12L13 18ZM4 18V6L12.5 12L4 18Z"
    xmlns="http://www.w3.org/2000/svg"
  />,
  "FastForward"
);
